/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IAddCartData,
  IBookingProceed,
  ICartData,
  ICartSummary,
  IState,
  IStore,
  paymentMethodType,
} from "../types";
import { initialState } from "./initialState";
import { set } from "lodash";

export const useClinicSlice = createSlice({
  name: "cartAddState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },

    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },
    setOfflineCartItems: (state, action: PayloadAction<IAddCartData[]>) => {
      state.offlineList = action.payload;
    },
    addToCart: (
      state,
      action: PayloadAction<{ data: IAddCartData; callback: () => void }>
    ) => {},

    doGetCartList: (
      state,
      action: PayloadAction<{
        data: { cartItems: IAddCartData[] ,  } | {};
        fetch?:boolean
      }>
    ) => {
      state.loading = true;
    },
    setList: (state, action: PayloadAction<ICartData>) => {
      state.list = action.payload;
    },
    cartItemsRemove: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>
    ) => {},
    cartRemove: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>
    ) => {},
    setStateList: (state, action: PayloadAction<IState[]>) => {
      state.stateList = action.payload;
    },

    updateCheckoutFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `checkoutForm.${action.payload.key}`, action.payload.value);
    },
    updateCheckoutFormValues: (state, action) => {
      const updates = action.payload;
      Object.entries(updates).forEach(([key, value]) => {
        set(state, `checkoutForm.${key}`, value);
      });
    },
    doGetShippingCalculation: (state, action: PayloadAction<paymentMethodType|"">) => {},
    getZipCodeAddress: (state, action: PayloadAction<{ zipcode: string ,callback: (data:any) => void;}>) => {},
    doBookingCreate: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},
    doGetStateList: (state) => {},

    bookingProceed: (
      state,
      action: PayloadAction<{
        paymentMethodType: paymentMethodType;
        storeId: string;
        callback: () => void;
      }>
    ) => {},
    setBookingProceedForm: (state, action: PayloadAction<IBookingProceed>) => {
      state.bookingProceedForm = action.payload;
    },
    setCartSummary: (state, action: PayloadAction<ICartSummary>) => {
      state.cartSummary = action.payload;
    },
    getStoreList: (state) => {},
    setStoreList: (state, action: PayloadAction<IStore[]>) => {
      state.storeList = action.payload;
    },

    clearCheckoutForm: (state) => {
      state.checkoutForm = initialState.checkoutForm;
      state.cartSummary = initialState.cartSummary;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
